var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"chat"},_vm._l((_vm.pComments),function(comment){return _c('div',{key:comment.id,class:{
      left: comment.accountType !== _vm.pOwnerType,
      right: comment.accountType === _vm.pOwnerType,
    }},[_c('p',[_c('strong',[_vm._v(" "+_vm._s(_vm._f("full-name")(_vm.getCommentOwner(comment)))+" ")]),_c('br'),_c('span',{domProps:{"innerHTML":_vm._s(_vm.parseComment(comment.comment))}})]),_c('span',{staticClass:"time",attrs:{"title":_vm._f("date")(comment.postedAt)}},[_vm._v(" "+_vm._s(_vm._f("time-ago")(comment.postedAt))+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }